import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export function initSentry() {
  if (!DSN) {
    // Em dev ou se a var não estiver configurada, não inicializa
    return;
  }

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE, // 'production' | 'development'
    release: import.meta.env.VITE_APP_VERSION ?? 'essencia@1.0.0',

    // Captura 10% das sessões em produção (ajuste conforme volume)
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

    // Replay de sessão apenas em produção — 1% aleatório + 100% em erros
    replaysSessionSampleRate: import.meta.env.PROD ? 0.01 : 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Nunca capturar conteúdo clínico
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Ignorar erros de rede/extensões de browser que não são nossos
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection',
      /^Network Error/,
      /^Request failed/,
      /ChunkLoadError/,
    ],

    beforeSend(event) {
      // Nunca enviar PII clínica — remover dados de request body
      if (event.request?.data) {
        event.request.data = '[REDACTED — dados clínicos]';
      }
      return event;
    },
  });
}

/** Associa o usuário autenticado ao Sentry (sem dados clínicos) */
export function setSentryUser(id: string, role: string) {
  Sentry.setUser({ id, role });
}

/** Limpa o usuário ao fazer logout */
export function clearSentryUser() {
  Sentry.setUser(null);
}
